import React from 'react';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import {generateRoutePath} from '@epic-core/common';
import errorBg from '../../../../images/error-fg.png';
import {ErrorPage, ErrorBox, H1, H2, P, StyledLink} from './Error.styles';

const Error404 = function Error404({staticContext}) {
    if (staticContext) {
        staticContext.status = 404;
    }

    return (
        <ErrorPage>
            <ErrorBox errorBg={errorBg}>
                <div>
                    <H1>404</H1>
                    <H2>
                        <Message code="epic.error.404.title1" />
                        <br />
                        <Message code="epic.error.404.title2" />
                    </H2>
                    <P>
                        <Message code="epic.error.404.msg" />
                    </P>
                    <StyledLink to={generateRoutePath('/')}>
                        <Message code="epic.error.404.home" />
                    </StyledLink>
                </div>
            </ErrorBox>
        </ErrorPage>
    );
};

Error404.propTypes = {
    staticContext: PropTypes.object
};

export default Error404;
